/*
 * @Description: 路由配置
 * @Author: PF
 * @Date: 2026-08-05 09:30:03
 * @LastEditors: PF
 * @LastEditTime: 2026-09-04 16:56:59
 */
import { createRouter, createWebHistory } from 'vue-router'
import { backToLogin } from '../utils/login.js'
import { menu } from '@/api/menu'
import Cookies from 'js-cookie'
import parIndex from '@/views/layout/parIndex.vue'
import ziLayout from '@/views/layout/subIndex.vue'

const routes = [
  // 登录回调
  {
    path: '/account/loginredirect',
    meta: { needLogin: false },
    component: () => import('@/views/account/LoginRedirect.vue')
  },

  // 文AI
  {
    path: '/wenAi',
    meta: { needLogin: true, keepAlive: true },
    component: () => import('@/views/account/wenAi.vue')
  },

  // 主布局
  {
    path: '/',
    name: 'home',
    component: parIndex,
    meta: { needLogin: true, keepAlive: true },
    redirect: '/',
    children: menu
  },
  
  // ===== 无需登录的大屏 / 看板 =====
  {
    path: '/xiaoqingjuecezhichi',
    meta: { title: '校情决策支持系统首页', needLogin: false },
    component: () => import('@/pages/xiaoqingjuecezhichi/xiaoqingjuecezhichihome.vue')
  },
  {
    path: '/xiaoyuanzonghe',
    meta: { title: '校园综合数据驾驶舱', needLogin: false },
    component: () => import('@/views/daping/xiaoyuanzonghe.vue')
  },
  {
    path: '/xiaoyuanshishi',
    meta: { title: '校园实时数据', needLogin: false },
    component: () => import('@/views/daping/xiaoyuanshishi.vue')
  },
  {
    path: '/jiaowujiaoxue',
    meta: { title: '教务教学数据看板', needLogin: false },
    component: () => import('@/views/daping/jiaowujiaoxue.vue')
  },
  {
    path: '/banxuetiaojian',
    meta: { title: '办学条件数据看板', needLogin: false },
    component: () => import('@/views/daping/banxuetiaojian.vue')
    // component: () => import('@/pages/xiaoqingjuecezhichi/kanban/banxuetiaojian/list.vue')
  },
  {
    path: '/sushegongyu',
    meta: { title: '宿舍公寓', needLogin: false },
    component: () => import('@/views/daping/sushegongyu.vue')
    // component: () => import('@/pages/sushe/renliankaoqin/susheloudashujupingtai/sushegongyu.vue')
  },
  {
    path: '/gundong',
    meta: { title: '滚动大屏', needLogin: false },
    component: () => import('@/pages/sushe/renliankaoqin/susheloudashujupingtai/gundong.vue')
  },
  {
    path: '/zhinengbiyeyujing',
    meta: { title: '智能毕业预警', needLogin: false },
    component: () => import('@/pages/jiaowu/biyeguanli/zhinengbiyeyujing.vue')
  },
  
  // 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: { needLogin: false },
    component: () => import('../../public/404/404.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由错误兜底
router.onError((error) => {
  if (/Loading chunk (\d)+ failed/.test(error.message)) {
    location.reload()
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = Cookies.get(process.env.VUE_APP_BASE_TOKEN)

  // 不需要登录
  if (to.meta?.needLogin === false) return next()

  // 需要登录且有 token
  if (token) return next()

  // 无权限
  backToLogin()
  next(false)
})

export default router
